import './App.css';

function App() {
  return (
    <div className="App" style={{ margin: 0, padding: 0 }}>
      <iframe
        src="https://www.hexagen.world/"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          border: 'none'
        }}
        title="Hexagen World"
      />
    </div>
  );
}

export default App;